
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntradaRequisicaoExterna } from '@models/RequisicaoExterna/EntradaRequisicaoExterna.model';
import { SaidaRequisicaoExterna } from '@models/RequisicaoExterna/SaidaRequisicaoExterna';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UtilService } from './util.service';

@Injectable({ providedIn: 'root' })
export class RequisicaoExternaService {

  constructor(private http: HttpClient, private utilService: UtilService) { }

  ObterResultado(pagina): Observable<SaidaRequisicaoExterna> {
    const url = `${this.utilService.funcaoObterURLAPI()}/requisicaoexterna/obterresultado`;
    var entrada = <EntradaRequisicaoExterna>{
      ticketUsuario: localStorage.getItem('ticketUsuario'),
      tipoRequisicao: pagina
    };

    return this.http.post<SaidaRequisicaoExterna>(url, entrada).pipe(
      map(obj => obj),
      catchError(e => this.errorHandler(e))
    );
  }

  errorHandler(e: any): Observable<any> {
    return e;
  }
}
